import { ECanadianProvince } from "./CanadianProvince";

export const CanadianJurisdiction = {
  CAN: "CAN", // Federal Canada
  ...ECanadianProvince,
} as const;

export type CanadianJurisdiction =
  (typeof CanadianJurisdiction)[keyof typeof CanadianJurisdiction];

export const CanadianJurisdictionNameMap = {
  "Federal Canada": CanadianJurisdiction.CAN,
  Alberta: CanadianJurisdiction.AB,
  "British Columbia": CanadianJurisdiction.BC,
  Manitoba: CanadianJurisdiction.MB,
  "New Brunswick": CanadianJurisdiction.NB,
  "Newfoundland and Labrador": CanadianJurisdiction.NL,
  "Nova Scotia": CanadianJurisdiction.NS,
  "Northwest Territories": CanadianJurisdiction.NT,
  Nunavut: CanadianJurisdiction.NU,
  Ontario: CanadianJurisdiction.ON,
  "Prince Edward Island": CanadianJurisdiction.PE,
  Quebec: CanadianJurisdiction.QC,
  Saskatchewan: CanadianJurisdiction.SK,
  Yukon: CanadianJurisdiction.YT,
} as const;

export const CanadianJurisdictionAbbrevToNameMap = {
  [CanadianJurisdiction.CAN]: "Federal Canada",
  [CanadianJurisdiction.AB]: "Alberta",
  [CanadianJurisdiction.BC]: "British Columbia",
  [CanadianJurisdiction.MB]: "Manitoba",
  [CanadianJurisdiction.NB]: "New Brunswick",
  [CanadianJurisdiction.NL]: "Newfoundland and Labrador",
  [CanadianJurisdiction.NS]: "Nova Scotia",
  [CanadianJurisdiction.NT]: "Northwest Territories",
  [CanadianJurisdiction.NU]: "Nunavut",
  [CanadianJurisdiction.ON]: "Ontario",
  [CanadianJurisdiction.PE]: "Prince Edward Island",
  [CanadianJurisdiction.QC]: "Quebec",
  [CanadianJurisdiction.SK]: "Saskatchewan",
  [CanadianJurisdiction.YT]: "Yukon",
} as const;
